let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1XEYQ")).then(() => parcelRequire('gAz4m'));